export default {
  template: '#vue-product-tile',
  delimiters: ['${', '}'],
  props: ['product'],
  computed: {
    save_story() {
      if (this.product.compare_at_price && this.product.compare_at_price_numeric > this.product.price_numeric) {
        return             Math.round(
                (this.product.compare_at_price_numeric - this.product.price_numeric) /
                this.product.compare_at_price_numeric * 100
            )
      }
      return null
    }
  }
}